<template>
  <div>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Ocorrências"
    >
      <h3>#{{ filledValue }}</h3>

      <div class="title_table">
        <b-tabs content-class="mt-3">
          <b-tab title="Ocorrência da viagem">
            <b-table
              class="nowrapActions kanban-board-card shLog"
              ref="table"
              :busy.sync="isBusy"
              :items="occurrences"
              :fields="fields"
              responsive="sm"
            >
              <template v-slot:cell(checklistId)="data">
                <a
                  href="#"
                  @click="openChecklistDatails(data.item.checklistId)"
                >
                  # <u>{{ data.item.checklistId }}</u>
                </a>
              </template>
            </b-table>
          </b-tab>
          <b-tab
            title="Histórico"
            v-if="integrationId == null || integrationId == 0"
            disabled
          >
            <p>Campo não possui histórico</p>
          </b-tab>
          <b-tab title="Histórico" v-else>
            <b-table
              class="nowrapActions kanban-board-card shLog"
              ref="table"
              :busy.sync="isBusy"
              :items="occurrences"
              :fields="fields"
              responsive="sm"
            >
              <template v-slot:cell(checklistId)="data">
                <a
                  href="#"
                  @click="openChecklistDatails(data.item.checklistId)"
                >
                  # <u>{{ data.item.checklistId }}</u>
                </a>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </div>
      <pendency-field-details-modal ref="checklistDetails" :id="checklistId" />
      <workflow-occurrences-filled-story-modal
        ref="occurrenceStory"
      ></workflow-occurrences-filled-story-modal>

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.close") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "WorkflowOccurrecesFilledModal",
  components: {
    "pendency-field-details-modal": () =>
      import("@/pagesRms/checklist/pendency/PedencyFieldDetailsModal.vue"),
    "workflow-occurrences-filled-story-modal": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowOccurrencesFilledStoryModal.vue"
      ),
  },
  data() {
    return {
      checklistId: "",
      fields: [
        {
          key: "createDate",
          filterKey: "createDate",
          label: "Data de criação",
          thStyle: "width: 10px;",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          label: "ChecklistId",
          thStyle: "width: 100px;",
        },
        {
          key: "description",
          filterKey: "description",
          label: "Descrição",
          thStyle: "width: 470px;",
        },
      ],
      filledValue: "",
      integrationId: 0,
      isBusy: false,
      occurrences: [],
    };
  },

  methods: {
    show(fieldFilledId, value) {
      console.log(value);
      this.filledValue = value;
      this.getOccurrencesByProcessId(fieldFilledId);
      this.$refs.openModal.show();
    },
    getOccurrencesByProcessId(fieldFilledId) {
      this.$apiWorkflow
        .get("/workflowOccurrence/getOccurrences/" + fieldFilledId)
        .then((response) => {
          console.log(response.data);
          this.occurrences = response.data;
          this.occurrences.forEach((item) => {
            this.integrationId = item.systemIntegrationFieldListId;
          });
        });
    },
    openChecklistDatails(checklistId) {
      this.checklistId = checklistId.toString();
      this.$refs.checklistDetails.open();
    },
    getStoryItens(ctx, callback) {
      this.$apiWorkflow
        .get("/workflowOccurrence/getOccurrencesSystem/" + this.integrationId)
        .then((response) => {
          callback(response.data);
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.title_table {
  border-bottom: none;
}
</style>
